module.exports = __webpack_public_path__ + "img/info2.3c31838.svg";